import { Skeleton } from "../feedback/Skeleton";
import s from "./Chart.module.css";

interface ChartStateProps {
  cargando?: boolean;
  vacio: string;
  titulo: string;
  descripcion: string;
}

export function ChartState({ cargando, vacio, titulo, descripcion }: ChartStateProps) {
  if (cargando) {
    return (
      <div className={s.estado} role="img" aria-label={`${titulo}. ${descripcion}`}>
        <span role="status">Cargando gráfico</span>
        <Skeleton lines={3} />
      </div>
    );
  }
  return (
    <div className={s.estado} role="img" aria-label={`${titulo}. ${descripcion}`}>
      {vacio}
    </div>
  );
}
